module.exports = __webpack_public_path__ + "https://gloprocessor.com/ment/img/topApg.6b005c8d.png";